<template>
  <div>
    <div class="control-section dashboard-api" id="dashboard-control-section">
      <div class="content-wrapper" style="max-width:100%">
        <EPanel ref="epanel" ></EPanel>
      </div>

    </div>
  </div>
</template>


<script>
import CustomDialog from '../../../components/common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import EPanel from '../../../components/deploymentManagement/kubernetesEnvironment/EPanel';



export default {
  name: 'kubernetesEnvironment',
  props: [
    'exportFlag'
  ],
  data() {
    return {
      widthNum: 3,
      spacing: 0,
      panelId:'e_panelId'
      
    };
  },
  
  components: {
    EPanel
  },
  mounted() {
    
    
        // this.$refs.epanel.getInitDatas();
  },
 
};
</script>